import script from "./uploadForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./uploadForm.vue?vue&type=script&lang=ts&setup=true"

import "./uploadForm.vue?vue&type=style&index=0&id=7c6173c3&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6173c3"]])

export default __exports__